import type { Block, BlockType } from '@geoic/shared';
import * as Content from './content-forms.js';
import * as Lists from './list-forms.js';
import * as Shop from './shop-forms.js';
import * as Special from './special-forms.js';

/**
 * Blok turi → tahrirlash formasi.
 *
 * `Record<BlockType, …>` ATAYLAB to'liq: yangi blok turi qo'shilib, formasi
 * yozilmasa `tsc` xato beradi. `switch` yoki `??` bilan yozilsa, yangi blok
 * adminda bo'sh panel ko'rsatib, buni faqat foydalanuvchi sezardi.
 */
const FORMS: Record<BlockType, (props: never) => React.ReactNode> = {
  // Umumiy (15)
  'hero-slider': Content.HeroSliderForm,
  'page-header': Content.PageHeaderForm,
  'rich-text': Content.RichTextForm,
  'text-image': Content.TextImageForm,
  stats: Content.StatsForm,
  features: Content.FeaturesForm,
  gallery: Content.GalleryForm,
  video: Content.VideoForm,
  faq: Content.FaqForm,
  accordion: Content.AccordionForm,
  timeline: Content.TimelineForm,
  partners: Content.PartnersForm,
  cta: Content.CtaForm,
  map: Content.MapForm,
  html: Content.HtmlForm,

  // Ro'yxatlar (7)
  'news-list': Lists.NewsListForm,
  'services-list': Lists.ServicesListForm,
  'projects-list': Lists.ProjectsListForm,
  'staff-list': Lists.StaffListForm,
  'documents-list': Lists.DocumentsListForm,
  'courses-list': Lists.CoursesListForm,
  'services-price': Lists.ServicesPriceForm,

  // Do'kon (5)
  'products-grid': Shop.ProductsGridForm,
  'product-slider': Shop.ProductSliderForm,
  'categories-grid': Shop.CategoriesGridForm,
  'brands-strip': Shop.BrandsStripForm,
  'product-compare': Shop.ProductCompareForm,

  // Boshqa (4)
  'droneshow-packages': Special.DroneshowPackagesForm,
  'droneshow-portfolio': Special.DroneshowPortfolioForm,
  'request-form': Special.RequestFormForm,
  'contact-info': Special.ContactInfoForm,
};

export type BlockDataFormProps = {
  block: Block;
  onChange: (block: Block) => void;
};

/**
 * Tanlangan blokning `data` formasi.
 *
 * Tur bo'yicha tanlash shu yerda YAKUNLANADI: pastda `data` va `onChange`
 * ning tipi har bir forma uchun aniq, chunki `block` discriminated union
 * va `block.type` uni toraytiradi.
 */
export function BlockDataForm({ block, onChange }: BlockDataFormProps) {
  const Form = FORMS[block.type] as (props: {
    data: Block['data'];
    onChange: (data: Block['data']) => void;
  }) => React.ReactNode;

  return <Form data={block.data} onChange={(data) => onChange({ ...block, data } as Block)} />;
}
